export enum ValidationType {
    required = "required",
    minimum = "min",
    maximum = "max",
    between = "between",
    email = "email",
    confirmed = "confirmed",
    regex = "regex",
    is = "is"
}
